import * as React from 'react';

const Logout24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M2.99915 2.25C3.41336 2.25 3.74915 2.58579 3.74915 3V21C3.7491 21.4142 3.41333 21.75 2.99915 21.75C2.58515 21.7498 2.24919 21.414 2.24915 21V3C2.24915 2.58593 2.58513 2.25023 2.99915 2.25ZM16.4689 7.46973C16.7617 7.17689 17.2365 7.17701 17.5294 7.46973L21.5177 11.459C21.5273 11.4682 21.536 11.4785 21.545 11.4883C21.567 11.5117 21.5872 11.5362 21.6056 11.5615C21.6945 11.6847 21.7491 11.8345 21.7491 11.998C21.7491 12.0423 21.7438 12.0858 21.7365 12.1279C21.711 12.2751 21.6431 12.4166 21.5294 12.5303L17.5294 16.5303C17.2365 16.8229 16.7617 16.8231 16.4689 16.5303C16.1762 16.2375 16.1763 15.7626 16.4689 15.4697L19.1906 12.749L6.99915 12.75C6.58519 12.7498 6.24923 12.414 6.24915 12C6.24914 11.586 6.58516 11.2503 6.99915 11.25L19.1876 11.249L16.4689 8.53027C16.1762 8.23745 16.1763 7.76258 16.4689 7.46973Z'
				fill='#333333'
			/>
		</svg>
	);
};

export default Logout24;
